import { AppState } from '@/store';

export const selectIsAuthorized = (state: AppState) => !!state.auth.login?.token;
export const selectAuthState = (state: AppState) => state.auth.login;
export const selectShowSetPasswordSuccess = (state: AppState) => state.auth.showSetPasswordSuccess;
export const selectLoginLoading = (state: AppState) => state.auth.login?.loading;
export const selectLoginError = (state: AppState) => state.auth.login?.error;
export const selectFlag = (state: AppState) => state.auth.login.flag;
export const selectHelpersShown = (state: AppState) => state.auth.login.helpersShown;
export const selectPaymentInfoPopupShown = (state: AppState) => state.auth.login.paymentInfoPopupShown;

// Reset password
export const resetLoading = (state: AppState) => !!state.auth.resetPassword?.loading;
